<template>
    <div class="c-formItem">
        <label class="c-formLabel">{{ label }}</label>
        <input class="c-formInput" type="text" :value="value" @input="$emit('input', $event.target.value)" />
    </div>
</template>

<script>
    export default {
        name: 'ui-Input',
        props: {
            label: String, // etiqueta del icono
            value: String, // nombre del icono
        },
    };
</script>
